const initialState = { incidentlog: [] }

export const incidentlog = (state = initialState, action) => {
	switch (action.type) {
  	case 'SET_INCIDENT_LOG':
      return { incidentlog: action.payload }; 
  }
  return state
}
